const Routes = {
  STOP_PLACE: "stop_place",
  GROUP_OF_STOP_PLACE: "group",
  REPORTS: "reports",
  IMPORT_NETEX_FILE: "importNetexFile",
};

export default Routes;
